import React, { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import UserCard from "~/components/UserCard/UserCard";
import { canAccessChat } from "~/store/selectors/selector.users";
import { UserCardContextProvider } from "./context";

export const UserCardProvider = ({ children }) => {
  const [userId, setUserId] = useState();
  const canOpenUserCard = useSelector(canAccessChat);

  return (
    <UserCardContextProvider
      value={{
        userId,
        setUserId,
      }}
    >
      {children}
      {userId && canOpenUserCard ? <UserCard id={userId} /> : null}
    </UserCardContextProvider>
  );
};

UserCardProvider.propTypes = {
  children: PropTypes.any,
};
